import type React from 'react';
import type { ReactElement } from 'react';

import { formatReadableDateShort, safeParseISO } from 'shared/util/datetime-fns';
import { thousandSeparated } from 'shared/util/formatting';

import type { HotelOffer } from '@/interfaces';
import { SupplierLogo } from '../resultList/images/SupplierLogo';

export type HotelResultHeaderProps = Pick<HotelOffer, 'supplier' | 'duration' | 'departureDate' | 'returnDate' | 'pricePerPerson'>;

export const HotelResultHeader: React.FC<HotelResultHeaderProps> = ({
    supplier,
    duration,
    departureDate,
    returnDate,
    pricePerPerson,
}): ReactElement<HotelResultHeaderProps> => {
    const parsedDepartureDate = safeParseISO(departureDate);
    const parsedReturnDate = safeParseISO(returnDate);

    return (
        <div className="flex  flex__justify_space_between">
            <div className="flex flex__column_mobile">
                <span className="flex__order_mobile_3 ">
                    <SupplierLogo supplier={supplier} />
                </span>
                <div className="u-strong u-caption flex__order_mobile_1 u-m-pl8 u-pt4" data-testid="ResultHeader-Duration">
                    {duration} dagers reise
                </div>
                <div className="u-hide-lt768 u-ml32" />
                <div className="u-caption flex__order_mobile_2 u-pt4" data-testid="ResultHeader-Dates">
                    <span className="u-no-break">{parsedDepartureDate && formatReadableDateShort(parsedDepartureDate)}</span>
                    <span className="icon-pre icon--one-way-arrow u-mr8 u-ml8" />
                    <span className="u-no-break">{parsedReturnDate && formatReadableDateShort(parsedReturnDate)}</span>
                </div>
            </div>
            <div className="flex flex__column_mobile u-text-right--lt768">
                <span className="u-caption flex__order_mobile_2">2 voksne,</span>
                <span className="u-caption flex__order_mobile_2">&nbsp;pris per pers.</span>
                <div className="u-hide-lt768 u-ml32" />
                <span className="u-b1 u-strong flex__order_mobile_1" data-testid="ResultHeader-Price">
                    {thousandSeparated(pricePerPerson)} kr
                </span>
            </div>
        </div>
    );
};
